import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { hotGossipItems } from '@/mocks/home';

export default function HotGossipSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 340;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
              <span className="text-primary-500">🔥</span> 热门爆料
              <span className="text-primary-500">实时追踪</span>
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              网红塌房黑料每日更新，一手大瓜不错过
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Link
              to="/category/all"
              className="hidden sm:inline-flex items-center gap-1 px-4 py-2 bg-foreground-950 text-white text-sm rounded-full whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              查看全部
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white text-foreground-700 hover:text-foreground-950 hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white text-foreground-700 hover:text-foreground-950 hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {hotGossipItems.map((item, index) => (
            <Link
              key={item.id}
              to="/category/all"
              className="flex-shrink-0 w-[300px] md:w-[340px] group cursor-pointer"
            >
              <div className="bg-white rounded-lg overflow-hidden transition-transform duration-200 group-hover:-translate-y-1">
                <div className="relative w-full h-[220px] md:h-[260px] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} - 吃瓜网站线路一`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading={index > 2 ? 'lazy' : 'eager'}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                      {item.category}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="px-3 py-1 bg-foreground-950/70 text-white text-xs font-bold rounded-full whitespace-nowrap">
                      🔥 {item.heat}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                    {item.summary}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    <span className="text-xs text-primary-500 font-medium flex items-center gap-1">
                      阅读全文
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-arrow-right-s-line text-xs"></i>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}